export { jmd, usd, jmdOnly, setFxRate, getFxRate, usdToJmd } from "./money";

export const CATEGORY_LABELS = {
  electronics: "Electronics",
  fashion: "Fashion",
  home: "Home",
  grocery: "Grocery",
  hardware: "Hardware",
  automotive: "Automotive",
  beauty: "Beauty",
  "jamaica-made": "Jamaica Made",
  business: "Business",
  services: "Services",
  mens: "Men's Wear",
  womens: "Women's Wear",
  shoes: "Shoes",
  jewelry: "Jewelry",
  art: "Caribbean Art",
  water: "Water Company",
  marine: "Sea Equipment & Gear",
  yachts: "Yachts",
  cigars: "Premium Cigars",
  pets: "Pets & Animals",
  "smart-locks": "Smart Locks & Security",
};

export function timeLeft(endsAt) {
  const diff = new Date(endsAt) - new Date();
  if (diff <= 0) return { done: true, label: "Ended" };
  const h = Math.floor(diff / 3.6e6);
  const m = Math.floor((diff % 3.6e6) / 6e4);
  const s = Math.floor((diff % 6e4) / 1000);
  return { done: false, h, m, s };
}
